import { render } from "./ButtonLink.vue?vue&type=template&id=a1a0d362&scoped=true"
import script from "./ButtonLink.vue?vue&type=script&lang=js"
export * from "./ButtonLink.vue?vue&type=script&lang=js"

import "./ButtonLink.vue?vue&type=style&index=0&id=a1a0d362&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a0d362"]])

export default __exports__